// src/pages/Reports/BillWiseProfitLoss/BillWiseProfitLossTable.js
import React from "react";
import { Table } from "antd";
import dayjs from "dayjs";
import _ from "lodash";

const BillWiseProfitLossTable = ({ data, productSummary, totals, filters, printMode }) => {
  const columns = [
    { title: "Code", dataIndex: "item_code", key: "item_code" },
    { title: "Product Name", dataIndex: "item_name", key: "item_name" },
    { title: "Sold Rate", dataIndex: "sale_rate", align: "right", render: (val) => Number(val || 0).toFixed(2) },
    { title: "Sold Quantity", dataIndex: "sale_qty", align: "right" },
    { title: "Sold", dataIndex: "netSoldAmount", align: "right", render: (val) => Number(val || 0).toFixed(2) },
    { title: "Purchase Rate", dataIndex: "purchase_average_rate", align: "right", render: (val) => Number(val || 0).toFixed(2) },
    { title: "Purchased", dataIndex: "purchasedAmount", align: "right", render: (val) => Number(val || 0).toFixed(2) },
    { title: "Profit/Loss", dataIndex: "productProfitLoss", align: "right", render: (val) => Number(val || 0).toFixed(2) },
  ];

  if (printMode && filters.filterType !== "product_summary") {
  return (
    <>
      {data.map((sale, idx) => {
        const subSold = _.sumBy(
          sale.details,
          (d) => Number(d.netSoldAmount || 0)
        );

        const subPurchased = _.sumBy(
          sale.details,
          (d) => Number(d.purchasedAmount || 0)
        );

        const subProfit = _.sumBy(
          sale.details,
          (d) => Number(d.productProfitLoss || 0)
        );

        return (
          <div key={idx} style={{ marginBottom: 20 }}>
            <div
              style={{
                marginBottom: 8,
                fontWeight: 600,
                fontSize: 12,
              }}
            >
              Sales Invoice No: {sale.sale_invoice} | Sales Date:{" "}
              {dayjs(sale.sale_created_isodt).format(
                "DD MMM YYYY hh:mm A"
              )}{" "}
              | Customer: {sale.customer_name} ({sale.customer_code})
            </div>

            <table className="ledger-print-table">
              <tbody>
                <tr className="ledger-print-heading">
                  <td>Code</td>
                  <td>Product Name</td>
                  <td>Sold Rate</td>
                  <td>Sold Qty</td>
                  <td>Sold</td>
                  <td>Rate</td>
                  <td>Purchased</td>
                  <td>Profit/Loss</td>
                </tr>

                {sale.details.map((row, index) => (
                  <tr key={index}>
                    <td>{row.item_code}</td>
                    <td>{row.item_name}</td>

                    <td style={{ textAlign: "right" }}>
                      {Number(row.sale_rate || 0).toFixed(2)}
                    </td>

                    <td style={{ textAlign: "right" }}>
                      {Number(row.sale_qty || 0).toFixed(2)}
                    </td>

                    <td style={{ textAlign: "right" }}>
                      {Number(row.netSoldAmount || 0).toFixed(2)}
                    </td>

                    <td style={{ textAlign: "right" }}>
                      {Number(
                        row.purchase_average_rate || 0
                      ).toFixed(2)}
                    </td>

                    <td style={{ textAlign: "right" }}>
                      {Number(row.purchasedAmount || 0).toFixed(2)}
                    </td>

                    <td style={{ textAlign: "right" }}>
                      {Number(
                        row.productProfitLoss || 0
                      ).toFixed(2)}
                    </td>
                  </tr>
                ))}

                <tr className="ledger-total-row">
                  <td
                    colSpan={4}
                    style={{
                      textAlign: "right",
                      fontWeight: 700,
                    }}
                  >
                    Sub Total :
                  </td>

                  <td style={{ textAlign: "right" }}>
                    {subSold.toFixed(2)}
                  </td>

                  <td></td>

                  <td style={{ textAlign: "right" }}>
                    {subPurchased.toFixed(2)}
                  </td>

                  <td style={{ textAlign: "right" }}>
                    {subProfit.toFixed(2)}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        );
      })}

      <table
        className="ledger-print-table"
        style={{ marginTop: 10 }}
      >
        <tbody>
          <tr className="ledger-total-row">
            <td>
              Total Sold : {totals.totalSold.toFixed(2)}
            </td>
            <td>
              Total Purchased :{" "}
              {totals.totalPurchased.toFixed(2)}
            </td>
            <td>
              Total Profit/Loss :{" "}
              {totals.totalProfit.toFixed(2)}
            </td>
            <td>
              Discount :{" "}
              {totals.totalDiscount.toFixed(2)}
            </td>
          </tr>
        </tbody>
      </table>
    </>
  );
}

if (printMode && filters.filterType === "product_summary") {
  return (
    <table className="ledger-print-table">
      <tbody>
        <tr className="ledger-print-heading">
          <td>Product Name</td>
          <td>Product Code</td>
          <td>Sold Qty</td>
          <td>Sold Amount</td>
          <td>Purchased Amount</td>
          <td>Profit Amount</td>
        </tr>

        {productSummary.map((row, index) => (
          <tr key={index}>
            <td>{row.prod_name}</td>
            <td>{row.prod_code}</td>
            <td style={{ textAlign: "right" }}>
              {row.prod_sold_qty}
            </td>
            <td style={{ textAlign: "right" }}>
              {row.prod_sold_amount}
            </td>
            <td style={{ textAlign: "right" }}>
              {row.prod_purchased_amount}
            </td>
            <td style={{ textAlign: "right" }}>
              {row.prod_profit_amount}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

  if (filters.filterType !== "product_summary") {
    return (
      <>
        {data.map((sale, idx) => {
          const subSold = _.sumBy(sale.details, d => Number(d.netSoldAmount || 0));
          const subPurchased = _.sumBy(sale.details, d => Number(d.purchasedAmount || 0));
          const subProfit = _.sumBy(sale.details, d => Number(d.productProfitLoss || 0));

          return (
            <div key={idx} className="mb-6">
              {!printMode && (
                <div className="font-semibold mb-2">
                  Sales Invoice No: {sale.sale_invoice} | Sales Date:{" "}
                  {dayjs(sale.sale_created_isodt).format("DD MMM YYYY hh:mm A")} | Customer:{" "}
                  {sale.customer_name} ({sale.customer_code})
                </div>
              )}
              <Table
                columns={columns}
                dataSource={sale.details}
                rowKey="item_code"
                pagination={false}
                bordered
                size="small"
                scroll={{ x: "max-content" }}
                summary={() => (
                  <Table.Summary.Row style={{ background: "#e6f4ff", fontWeight: "bold" }}>
                    <Table.Summary.Cell colSpan={4} align="right">
                      Sub Total:
                    </Table.Summary.Cell>
                    <Table.Summary.Cell align="right">{Number(subSold).toFixed(2)}</Table.Summary.Cell>
                    <Table.Summary.Cell />
                    <Table.Summary.Cell align="right">{Number(subPurchased).toFixed(2)}</Table.Summary.Cell>
                    <Table.Summary.Cell align="right">{Number(subProfit).toFixed(2)}</Table.Summary.Cell>
                  </Table.Summary.Row>
                )}
              />
            </div>
          );
        })}

        {data.length > 0 && (
          <div
            style={{
              marginTop: "12px",
              padding: "10px 16px",
              background: "#5f726d",
              color: "white",
              fontWeight: "bold",
              display: "flex",
              justifyContent: "space-between",
              borderRadius: "4px",
            }}
          >
            <span>Total Sold: {totals.totalSold.toFixed(2)}</span>
            <span>Total Purchased: {totals.totalPurchased.toFixed(2)}</span>
            <span>Total Profit/Loss: {totals.totalProfit.toFixed(2)}</span>
            <span>Discount: {totals.totalDiscount.toFixed(2)}</span>
          </div>
        )}
      </>
    );
  }
  
  // product summary mode
  return (
    <Table
      dataSource={productSummary}
      rowKey="prod_code"
      pagination={false}
      size="small"
      scroll={{ x: "max-content" }}
      columns={[
        { title: "Product Name", dataIndex: "prod_name" },
        { title: "Product Code", dataIndex: "prod_code" },
        { title: "Sold Qty", dataIndex: "prod_sold_qty", align: "right" },
        { title: "Sold Amount", dataIndex: "prod_sold_amount", align: "right" },
        { title: "Purchased Amount", dataIndex: "prod_purchased_amount", align: "right" },
        { title: "Profit Amount", dataIndex: "prod_profit_amount", align: "right" },
      ]}
    />
  );
};

export default BillWiseProfitLossTable;
